// src/data/inclusion.js - RULING 305.12 (by delegation, Record 652): ruling 305.6, Bob 2026-10-11, verbatim: "Default is no,
// not unless they voluntarily include the claimant by invite. I think the claimant should also be able to click a button
// requsting they include him in any discussions regarding the submitted claim but the officers are under no legal
// obligation to honor that request, but i would caution them against denying it".
//
// "The discussions" on the platform are the officers' notes on the claim (305.7: the union's while the union works it).
// Included, the claimant reads every one of them as it is written - not only those released to him. PURE.
const s = (v) => (v == null ? '' : String(v)).trim();

export const OFFICER_CAUTION = 'You are under no obligation to grant this request. Refusing it is cautioned against: the member '
  + 'will read every note in time anyway, and a refusal is itself on the record of his claim.';
export const MEMBER_ASK_TEXT = 'Ask to be included in your representatives\' discussions of this claim';
export const MEMBER_ASK_EXPLAIN = 'If they include you, you read their notes on your claim as they write them. They are not '
  + 'required to agree. Either way their notes reach you when the claim comes back to you or goes to the carrier, or after 30 days.';

const isOfficer = (u) => !!u && (u.isAdmin === true || ['admin', 'local_chair', 'general_chair'].includes(s(u.role)));

export function inclusionState(claim) {
  const c = claim || {};
  if (c.claimantIncluded === true) return 'included';
  const req = c.inclusionRequest;
  const dec = c.inclusionDecision;
  if (req && (!dec || s(dec.decision) === '' )) return 'asked';
  if (dec && dec.decision === 'declined') return 'declined';
  return 'none';
}

// The claimant's own ask. serverTime: the caller's serverTimestamp() (the rule pins it).
export function askPatch(claim, user, serverTime) {
  const st = inclusionState(claim);
  if (!user || !user.uid) return { ok: false, errors: ['Not signed in.'], patch: null };
  if (s((claim || {}).status) === 'draft') return { ok: false, errors: ['A draft is yours alone - there is nothing to be included in yet.'], patch: null };
  if (st === 'included') return { ok: false, errors: ['You are already included.'], patch: null };
  if (st === 'asked') return { ok: false, errors: ['Your request is already with your representatives.'], patch: null };
  return { ok: true, errors: [], patch: { inclusionRequest: { askedAt: serverTime, askedByUid: user.uid }, inclusionDecision: null } };
}

// An officer includes the claimant (with or without a request - an invitation), or declines a request, giving a reason.
export function decisionPatch(claim, user, include, reason, serverTime) {
  const errors = [];
  if (!isOfficer(user)) errors.push('Only an officer decides this.');
  if (s((claim || {}).status) === 'draft') errors.push('Not on a draft.');
  const st = inclusionState(claim);
  if (include && st === 'included') errors.push('The member is already included.');
  if (!include && st !== 'asked') errors.push('There is no request to decline.');
  const why = s(reason);
  if (!include && why.length < 10) errors.push('Say why, in a sentence - a refusal is on the record of his claim.');
  if (errors.length) return { ok: false, errors, patch: null };
  const decision = { decision: include ? 'included' : 'declined', byUid: user.uid, byName: s(user.name || user.email), role: s(user.role || (user.isAdmin ? 'admin' : '')), at: serverTime, reason: why };
  return { ok: true, errors: [], patch: include ? { claimantIncluded: true, inclusionDecision: decision } : { inclusionDecision: decision } };
}
